import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { useTerritorio } from "../../context/TerritorioContext";
import { obtenerTerritoriosCacheados } from "../api/catalogosCache";

const selectStyles = {
  control: (base) => ({ ...base, minHeight: 38, fontSize: 13 }),
  menuPortal: (base) => ({ ...base, zIndex: 2000 }), // por encima del propio modal (backdrop="static")
};

export default function TerritorioModal({ show }) {
  const { setData } = useTerritorio();
  const [territorios, setTerritorios] = useState([]);
  const [porTerritorio, setPorTerritorio] = useState({});
  const [territorio, setTerritorio] = useState("");
  const [comunidad, setComunidad] = useState("");

  // Lectura INSTANTÁNEA del caché — nada de esperar a la red. La
  // pantalla de "Preparando la aplicación" (useCatalogosListos) ya
  // garantiza que esto esté descargado antes de que este modal llegue
  // a mostrarse, así que funciona igual con o sin conexión.
  useEffect(() => {
    if (!show) return;
    obtenerTerritoriosCacheados().then(({ territorios, porTerritorio }) => {
      setTerritorios(territorios);
      setPorTerritorio(porTerritorio);
    });
  }, [show]);

  // Al cambiar el territorio, las comunidades salen del mismo mapa ya
  // cacheado — no hay que volver a pedirle nada a nadie.
  useEffect(() => {
    setComunidad("");
  }, [territorio]);

  const comunidadesDisponibles = territorio ? (porTerritorio[territorio] || []) : [];

  const guardar = () => setData({ territorio, comunidad });

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>🌎 Selección inicial</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Territorio *</Form.Label>
            <Select
              placeholder="Buscar territorio..."
              options={territorios.map(t => ({ value: t, label: t }))}
              value={territorio ? { value: territorio, label: territorio } : null}
              onChange={(sel) => setTerritorio(sel?.value || "")}
              isClearable
              menuPlacement="auto"
              menuPosition="fixed"
              styles={selectStyles}
              noOptionsMessage={() => "Sin territorios descargados — revisa tu conexión al menos una vez"}
            />
          </Form.Group>

          {territorio && (
            <Form.Group className="mt-3">
              <Form.Label>Comunidad / Barrio *</Form.Label>
              <Select
                placeholder="Buscar comunidad..."
                options={comunidadesDisponibles.map(c => ({ value: c, label: c }))}
                value={comunidad ? { value: comunidad, label: comunidad } : null}
                onChange={(sel) => setComunidad(sel?.value || "")}
                isClearable
                menuPlacement="auto"
                menuPosition="fixed"
                styles={selectStyles}
                noOptionsMessage={() => "Sin comunidades para este territorio"}
              />
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={guardar} disabled={!territorio || !comunidad}>Ingresar</Button>
      </Modal.Footer>
    </Modal>
  );
}